<template>
  <div>
    	 <el-input v-model="timeVal" @focus="focus" :disabled="showTime" :readonly="showTime" :label="item.titleName" ref="vdatetime" :placeholder="item.titleName"/>
					 <van-popup class="popup" v-model="showDate" :close-on-click-overlay="false">
						  <van-datetime-picker
              v-model="currentDate"
              type="datetime"
              title="选择完整时间"
              @confirm="confirm"
              @change="changeValue"
              @cancel="cancel"
             />
					 </van-popup>
  </div>
</template>
<script>
import PubSub from 'pubsub-js'
export default {
  name:'vDataPicker',
  props:{
    defaultValue: [String, Number,Array],//默认值
    item:Object,
     modelName: [String,Number],//字段名称
     disabled: [Boolean,Number],//禁用
  },
  data(){
    return{
        //vant 日期组件
        timeVal:"",
				 showDate:false,
        //  maxDate: new Date(2025, 10, 1),
         currentDate: new Date(),
         levelTitle1:'',
        timeStart:undefined,
        timeEnd:undefined,
        levelTitleJB:"",
        levelTitleLB:"",
        otherLB:[],
        showTime:false
    }
  },
  mounted(){
    this.showTime = this.disabled
      //涉及其他危险作业
      this.$eventBus.$on('otherList',otherL=>{
            this.otherLB=otherL;
            sessionStorage.setItem('otherLB',JSON.stringify(otherL))
            if(sessionStorage.getItem('satrttime')
           && sessionStorage.getItem('endtime') 
           && sessionStorage.getItem('levelTitleCodeLB')
           && sessionStorage.getItem('levelTitleCodeJB')
           && sessionStorage.getItem('otherLB')
           ){
               if(this.modelName=='DHZY_ZYJSSJ'){
                  // this.levelTitleLBfn(sessionStorage.getItem('satrttime'),sessionStorage.getItem('endtime'),sessionStorage.getItem('levelTitleCodeLB'),sessionStorage.getItem('levelTitleCodeJB'),sessionStorage.getItem('otherLB'))
               }
            }
      })
      //新增时获取作业级别
       this.$eventBus.$on('levelTitleCodeJB',levelTitleCodeJB=>{
        if(levelTitleCodeJB){
          this.levelTitleJB=levelTitleCodeJB;
          // console.log(levelTitleCodeJB)
          sessionStorage.setItem('levelTitleCodeJB',levelTitleCodeJB)
           if(sessionStorage.getItem('satrttime')
           && sessionStorage.getItem('endtime') 
           && sessionStorage.getItem('levelTitleCodeLB')
           && sessionStorage.getItem('levelTitleCodeJB')
           && sessionStorage.getItem('otherLB')
           ){
               if(this.modelName=='DHZY_ZYJSSJ'){
                  // this.levelTitleLBfn(sessionStorage.getItem('satrttime'),sessionStorage.getItem('endtime'),sessionStorage.getItem('levelTitleCodeLB'),sessionStorage.getItem('levelTitleCodeJB'),sessionStorage.getItem('otherLB'))
               }
            }
        }
      })
       this.$eventBus.$on('levelTitleCodeLB',levelTitleCodeLB=>{
        if(levelTitleCodeLB){
          this.levelTitleLB=levelTitleCodeLB;
          sessionStorage.setItem('levelTitleCodeLB',levelTitleCodeLB)
           if(sessionStorage.getItem('satrttime')
           && sessionStorage.getItem('endtime') 
           && sessionStorage.getItem('levelTitleCodeLB')
           && sessionStorage.getItem('levelTitleCodeJB')
           && sessionStorage.getItem('otherLB')
           ){
               if(this.modelName=='DHZY_ZYJSSJ'){
                  // this.levelTitleLBfn(sessionStorage.getItem('satrttime'),sessionStorage.getItem('endtime'),sessionStorage.getItem('levelTitleCodeLB'),sessionStorage.getItem('levelTitleCodeJB'),sessionStorage.getItem('otherLB'))
               }
            }
        }
      })
      let formdataObj=sessionStorage.getItem('detailParams');
       if(formdataObj!==undefined ||formdataObj!==null){
          if(formdataObj==null)formdataObj={}
          else{
          formdataObj=JSON.parse(formdataObj)
          let obj=formdataObj.formData;
          if('DHZY_ZYKSSJ' in obj){this.timeStart=obj.DHZY_ZYKSSJ}
          else{
             PubSub.subscribe('formInfoData',(msg,params) => {//订阅表单数据
            // console.log(params)
            this.formData(params)
          })  
          }
          if('DHZY_ZYJSSJ' in obj){this.timeEnd=obj.DHZY_ZYJSSJ}else{
            PubSub.subscribe('formInfoData',(msg,params) => {//订阅表单数据
            // console.log(params)
            this.formData(params)
          })  
          }
          }
      }
  },
  methods:{
        formData(params){
        let dateString1= (new Date()).Format('yyyy-MM-dd hh:mm');//now
        let currentTime=this.dateTostring(dateString1);
        if(params.DHZY_ZYKSSJ){//作业开始时间
          if(params.DHZY_ZYKSSJ!==""){
          this.timeStart= params.DHZY_ZYKSSJ
         }
        }
         if(params.DHZY_ZYJSSJ){//作业结束时间
          if(params.DHZY_ZYJSSJ!==""){
          this.timeEnd= params.DHZY_ZYJSSJ
          // console.log( this.timeEnd)
         }
        }
      },
       dateTostring(dateTime) {
					     let dateList,date,time;
                 if( dateTime!==undefined){
                   dateList = dateTime.split(' ')
                   }
                 if(dateList!==undefined){
                  date = dateList[0].split('-').join('')
                  dateList[1]=dateList[1]+":"
                   time = dateList[1].split(':')
                   	time.pop()
					     	   time = time.join('')
                 }
        },
       focus(){
         if(this.showTime) return;
         this.showDate=true
       },
       confirm(value){
           this.showDate=false;
            let year,month,date,hours,minutes,second;
            year=value.getFullYear();
            month=value.getMonth()+1;
            if(month<10)month='0'+month
            date=value.getDate();
            if(date<10) date='0'+date
            hours=value.getHours()
            if(hours<10) hours='0'+hours
            minutes=value.getMinutes()
            if(minutes<10)minutes='0'+minutes
            second=value.getSeconds()
            if(second<10)second='0'+second
            let selectTime=year+'-'+month+'-'+date+' '+hours+':'+minutes
            let dateString = (new Date()).Format('yyyy-MM-dd hh:mm');//now
                function dateTostring(dateTime) {
                 let dateList,date,time;
                 if( dateTime!==undefined){
                   dateList = dateTime.split(' ')
                   }
                 if(dateList!==undefined){
                  date = dateList[0].split('-').join('')
                  dateList[1]=dateList[1]+":"
                   time = dateList[1].split(':')
                   	time.pop()
					     	   time = time.join('')
                 }
					     	return date + time
               }
							 let selectTime1 =dateTostring(selectTime)
               let currentTime = dateTostring(dateString)
               if(selectTime1 < currentTime){
                  this.$message({
					     		message: '开始时间需要在当前时间以后，请重新选择',
					     		type: 'error'
                 })
                 selectTime="";
							 }else{
                  if(this.$refs.vdatetime.label=="作业开始时间"){
                        this.satrttime=selectTime1;
                        this.$eventBus.$emit('satrttime',this.satrttime)
                          sessionStorage.setItem('satrttime',this.satrttime)
                  }
                  if(this.$refs.vdatetime.label=="作业结束时间"){
                        this.endtime=selectTime1;
                        this.$eventBus.$emit('endtime',this.endtime)
                         sessionStorage.setItem('endtime',this.endtime)
                // console.log(this.levelTitleLB,this.levelTitleJB)
                    if(sessionStorage.getItem('satrttime')
                    && sessionStorage.getItem('endtime') 
                    && sessionStorage.getItem('levelTitleCodeLB') 
                    && sessionStorage.getItem('levelTitleCodeJB')
                    && sessionStorage.getItem('otherLB')
                    ){
                      // this.timeVal(sessionStorage.getItem('satrttime'),sessionStorage.getItem('endtime'),30000,72,this.levelTitleLB,this.levelTitleJB)
                     let code= this.levelTitleLBfn(sessionStorage.getItem('satrttime'),sessionStorage.getItem('endtime'),sessionStorage.getItem('levelTitleCodeLB'),sessionStorage.getItem('levelTitleCodeJB'),sessionStorage.getItem('otherLB'))
                      if(code){
                         selectTime=""
                      }
                    }
                  }
                  if(this.$refs.vdatetime.label=="确认开始时间" || this.$refs.vdatetime.label=="确认结束时间"){
                      this.satrttime=selectTime1;
                        let selectTime2 =dateTostring(this.timeStart)
                        let selectTime3 =dateTostring(this.timeEnd)
                    if(selectTime1!==""){
                        if(selectTime1<selectTime2 || selectTime1>selectTime3){
                                  this.$message({
                                   message: '确认时间超过作业时间段，重新选择',
                                   type:'error'
                                  })
                                 selectTime="";
                                }
                    }
                  }
                  //  console.log(this.$refs.vdatetime.label)
                  if(this.$refs.vdatetime.label=="交底开始时间"){
                        this.satrttime=selectTime1;
                        let selectTime2 =dateTostring(this.timeStart)
                        let selectTime3 =dateTostring(this.timeEnd)
                        if(selectTime1!==""){
                         if(selectTime1<selectTime2 || selectTime1>selectTime3){
                          this.$message({
                           message: '交底时间超过作业时间段，重新选择',
                           type:'error'
                          })
                          selectTime="";
                        }
                        }
                  }
                  if(this.$refs.vdatetime.label=="交底结束时间"){
                        this.endtime=selectTime1;
                        let selectTime2 =dateTostring(this.timeStart)
                        let selectTime3 =dateTostring(this.timeEnd)
                         if(selectTime1!==""){
                            if(selectTime1<selectTime2 || selectTime1>selectTime3){
                          this.$message({
                           message: '交底时间超过作业时间段，重新选择',
                           type:'error'
                          })
                          selectTime="";
                           }
                         }
                  }
                 this.timeVal=selectTime;
                 this.$emit('changeValue', {value:this.timeVal})
               }
       },
        levelTitleLBfn(start,end,levetitleLB,levetitleJB,otherLB){
          // console.log(start,end,levetitleLB,levetitleJB,otherLB)
        if(this.modelName=='DHZY_ZYJSSJ'){
          //有限
          if(levetitleLB.indexOf('有限')!==-1 || otherLB.indexOf('有限')!==-1){
              let code= this.timeVal1(start,end,750,'有限空间作业,危险作业均不超过8h，重新选择')
                if(code){return true}
          }else if(levetitleLB.indexOf('受限')!==-1 || otherLB.indexOf('受限')!==-1){
              let code= this.timeVal1(start,end,750,'受限空间作业,危险作业均不超过8h，重新选择')
                if(code){return true}
          }else{
            //其它
            if(levetitleJB.indexOf('一般')!==-1){
                if((levetitleLB.indexOf('进出仓')!==-1 || otherLB.indexOf('进出仓')!==-1) || (levetitleLB.indexOf('动火')!==-1 || otherLB.indexOf('动火')!==-1)){
                     let code= this.timeVal1(start,end,30000,'一般危险作业,进出仓、动火作业不得超过3天，重新选择')
                     if(code){return true}
                }else{
                    if((levetitleLB.indexOf('吊装')!==-1 || otherLB.indexOf('吊装')!==-1) || (levetitleLB.indexOf('高处')!==-1 || otherLB.indexOf('高处')!==-1) ){
                    let code= this.timeVal1(start,end,70000,'一般危险作业,高处、吊装作业不超过7天，重新选择')
                    if(code){return true}
                    }
                }
              }
            if(levetitleJB.indexOf('较大')!==-1){
              //8
              if((levetitleLB.indexOf('吊装')!==-1 || otherLB.indexOf('吊装')!==-1) ){
                let code= this.timeVal1(start,end,750,'较大危险作业,吊装作业不得超过8h，重新选择')
                if(code){return true}
              }else{
                //12
                if((levetitleLB.indexOf('动火')!==-1 || otherLB.indexOf('动火')!==-1) ){
                let code= this.timeVal1(start,end,1000,'较大危险作业,动火作业不得超过12h，重新选择')
                if(code){return true}
                }
                //24
                if((levetitleLB.indexOf('高处')!==-1 || otherLB.indexOf('高处')!==-1) ){
                let code= this.timeVal1(start,end,2000,'较大危险作业,高处作业不得超过24h，重新选择')
                if(code){return true}
                }
                //72
                if((levetitleLB.indexOf('进出仓')!==-1 || otherLB.indexOf('进出仓')!==-1) ){
                let code= this.timeVal1(start,end,30000,'较大危险作业,进出仓作业不得超过3天，重新选择')
                if(code){return true}
                }
              }
            }
            if(levetitleJB.indexOf('高度')!==-1){
              //8h
               if((levetitleLB.indexOf('吊装')!==-1 || 
               otherLB.indexOf('吊装')!==-1) || 
               (levetitleLB.indexOf('动火')!==-1 || otherLB.indexOf('动火')!==-1)){
                let code= this.timeVal1(start,end,750,'高度危险作业，吊装、动火作业均不得超过8h，重新选择')
                if(code){return true}
              }
               if((levetitleLB.indexOf('进出仓')!==-1 || 
               otherLB.indexOf('进出仓')!==-1) || 
               (levetitleLB.indexOf('高处')!==-1 || otherLB.indexOf('高处')!==-1)){
                let code= this.timeVal1(start,end,1000,'高度危险作业，进出仓、高处作业均不得超过12h，重新选择')
                if(code){return true}
              }
            }
          }
         
         }
          // if(levetitleLB.indexOf('动火作业')!==-1){
          //   if(levetitleJB.indexOf('一般危险')!==-1){
          //     let code= this.timeVal(start,end,30000,72,levetitleLB,levetitleJB)
          //     if(code){return true}
          //   }
          //   if(levetitleJB.indexOf('较大危险')!==-1){
          //     let code= this.timeVal(start,end,1000,12,levetitleLB,levetitleJB)
          //     if(code){return true}
          //   }
          //   if(levetitleJB.indexOf('高度危险')!==-1){
          //     let code= this.timeVal(start,end,750,8,levetitleLB,levetitleJB)
          //     if(code){return true}
          //   }
          // }
      },
      timeValfn1(start,end,levetitleLB,levetitleJB,otherLB,count,typetitle,msg){
          if(levetitleLB.indexOf(typetitle)!==-1 || otherLB.indexOf(typetitle)!==-1){
            let code= this.timeVal(start,end,750,msg)
            if(code){return true}
          }
      },
      timeVal1(start,end,count,msg){
        if(end-start>count){
          if(this.modelName=='DHZY_ZYJSSJ'){
             this.$message({
               message:''+msg,
               type:'error'
            })
            // console.log(this.defaultIndex,this.modelName)
            // this.$emit('changeValue', {index:this.defaultIndex,value:'',modelName:this.modelName})
            this.timeVal="";
             this.$emit('changeValue', {value:this.timeVal})
            // sessionStorage.removeItem('endtime')
             return true;
          }
        }
      },
       changeValue(picker){ // daterange 日期范围 datetimerange 日期和时间范围 返回一个数组
       },
       cancel(){
          this.showDate=false;
       },
       colse(){
       },
  },
  watch: {
      defaultValue:{
        handler(val,oldVal){
          if(val != ""){
            this.timeVal =  this.defaultValue
          }else{
            this.timeVal = ''
          }
        },
        deep:true,
        immediate:true
      },
      levelTitle1(val,oldVal){
        if(val!==""){

        }
      }
    },
}
</script>
<style scoped>
   .van-popup--center{
     width: 300px;
   }
</style>
